import React, { createContext, useState, } from 'react';
export var PTCDocumentsContext = createContext({
    openPTCDocumentDrawer: false,
    setOpenPTCDocumentDrawer: function () { return false; },
    selectedDocument: undefined,
    setSelectedDocument: function () { return undefined; },
    handleCloseDrawer: function () { return undefined; },
    documentLoadingError: false,
    setDocumentLoadingError: function () { return undefined; },
});
export var PTCDocumentsProvider = function (_a) {
    var children = _a.children;
    var _b = useState(false), openPTCDocumentDrawer = _b[0], setOpenPTCDocumentDrawer = _b[1];
    var _c = useState(undefined), selectedDocument = _c[0], setSelectedDocument = _c[1];
    var _d = useState(false), documentLoadingError = _d[0], setDocumentLoadingError = _d[1];
    // Function to handle closing the drawer and clearing the selected document
    var handleCloseDrawer = function () {
        // Closing the drawer first
        setOpenPTCDocumentDrawer(false);
        // Clear the selected document after a short delay to not have a flicker in the UI
        // when the drawer closes
        setTimeout(function () {
            setSelectedDocument(undefined);
            setDocumentLoadingError(false);
        }, 400);
    };
    return (React.createElement(PTCDocumentsContext.Provider, { value: {
            openPTCDocumentDrawer: openPTCDocumentDrawer,
            setOpenPTCDocumentDrawer: setOpenPTCDocumentDrawer,
            selectedDocument: selectedDocument,
            setSelectedDocument: setSelectedDocument,
            handleCloseDrawer: handleCloseDrawer,
            documentLoadingError: documentLoadingError,
            setDocumentLoadingError: setDocumentLoadingError,
        } }, children));
};
export default PTCDocumentsProvider;
